import { useEffect, useState } from "react";
import { Download, Trash2, Copy } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { ConfirmDelete } from "./ConfirmDelete";

export const AdminSubscribers = ({ onChange }) => {
  const [list, setList] = useState([]);
  const load = () => api.get("/admin/subscribers").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);
  const remove = async (id) => { await api.delete(`/admin/subscribers/${id}`); toast.success("Iscritto rimosso"); load(); onChange?.(); };

  const exportCsv = () => {
    const rows = [["email", "data_iscrizione"], ...list.map((s) => [s.email, s.created_at])];
    const blob = new Blob([rows.map((r) => r.join(",")).join("\n")], { type: "text/csv" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = "iscritti-newsletter.csv";
    a.click();
  };
  const copyAll = () => { navigator.clipboard.writeText(list.map((s) => s.email).join(", ")); toast.success("Email copiate"); };

  return (
    <div data-testid="admin-subscribers">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-6">
        <h2 className="font-display text-2xl font-bold uppercase tracking-tight">Iscritti newsletter ({list.length})</h2>
        <div className="flex gap-2">
          <button onClick={copyAll} disabled={!list.length} data-testid="admin-subscribers-copy-btn" className="inline-flex items-center gap-2 rounded-full border border-white/15 px-4 py-2 text-sm hover:border-emerald-500/60 disabled:opacity-50"><Copy className="h-4 w-4" /> Copia email</button>
          <button onClick={exportCsv} disabled={!list.length} data-testid="admin-subscribers-export-btn" className="inline-flex items-center gap-2 rounded-full bg-emerald-500 text-black px-4 py-2 text-sm font-semibold hover:bg-emerald-400 disabled:opacity-50"><Download className="h-4 w-4" /> Esporta CSV</button>
        </div>
      </div>
      <p className="text-xs text-zinc-500 mb-4">Esporta la lista e importala nel tuo servizio newsletter (es. Mailchimp, Brevo) per annunciare le nuove uscite.</p>
      {!list.length && <p className="text-sm text-zinc-400 border border-dashed border-white/15 p-10 text-center" data-testid="admin-subscribers-empty">Ancora nessun iscritto.</p>}
      <div className="divide-y divide-white/5 border border-white/10">
        {list.map((s) => (
          <div key={s.id} className="flex items-center gap-4 px-4 py-3 bg-[#0d0e12]" data-testid={`admin-subscriber-${s.id}`}>
            <span className="flex-1 text-sm truncate">{s.email}</span>
            <span className="font-mono-tga text-[10px] text-zinc-500">{new Date(s.created_at).toLocaleDateString("it-IT")}</span>
            <ConfirmDelete onConfirm={() => remove(s.id)} testid={`admin-delete-subscriber-${s.id}`} title={`Rimuovere ${s.email}?`}><Trash2 className="h-4 w-4" /></ConfirmDelete>
          </div>
        ))}
      </div>
    </div>
  );
};
